import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, normalizeStyle as _normalizeStyle, withDirectives as _withDirectives, vModelDynamic as _vModelDynamic, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers } from "vue"
import _imports_0 from '../assets/t_logo.png'


const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row bg-dange text-center justify-content-center" }
const _hoisted_3 = { class: "fs-3" }
const _hoisted_4 = {
  key: 0,
  class: "text-primary mt-5 d-flex align-self-center flex-column text-center"
}
const _hoisted_5 = {
  key: 1,
  class: "card card-body shadow"
}
const _hoisted_6 = { class: "row mb-sm-2" }
const _hoisted_7 = { class: "col-form-label col-sm-4" }
const _hoisted_8 = {
  key: 0,
  class: "badge bg-danger me-2"
}
const _hoisted_9 = { class: "col-sm-8" }
const _hoisted_10 = ["readonly"]
const _hoisted_11 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_12 = {
  key: 0,
  class: "mt-3"
}
const _hoisted_13 = { class: "offset-sm-4 ps-2" }
const _hoisted_14 = { class: "fs-3" }
const _hoisted_15 = { class: "mt-4 offset-sm-4 ps-2" }
const _hoisted_16 = ["href"]
const _hoisted_17 = ["href"]
const _hoisted_18 = ["href"]
const _hoisted_19 = ["href"]
const _hoisted_20 = {
  key: 1,
  class: "row mb-sm-2"
}
const _hoisted_21 = { class: "col-sm-8" }
const _hoisted_22 = { class: "input-group" }
const _hoisted_23 = ["readonly", "type"]
const _hoisted_24 = {
  class: "fs-6 position-absolute w-100 text-primary",
  style: {"left":"0px","top":"-8px"}
}
const _hoisted_25 = { class: "badge bg-primary" }
const _hoisted_26 = {
  key: 2,
  class: "mt-3 mb-3"
}
const _hoisted_27 = {
  key: 3,
  class: "row mb-sm-2"
}
const _hoisted_28 = { class: "col-sm-8" }
const _hoisted_29 = { class: "input-group" }
const _hoisted_30 = ["readonly", "type"]
const _hoisted_31 = {
  class: "fs-6 position-absolute w-100 text-primary",
  style: {"left":"0px","top":"-8px"}
}
const _hoisted_32 = { class: "badge bg-primary" }
const _hoisted_33 = { class: "row mb-sm-2" }
const _hoisted_34 = { class: "col-form-label col-sm-4" }
const _hoisted_35 = {
  key: 0,
  class: "badge bg-danger me-2"
}
const _hoisted_36 = { class: "col-sm-8" }
const _hoisted_37 = ["readonly"]
const _hoisted_38 = {
  key: 4,
  class: "mt-3 mb-3"
}
const _hoisted_39 = {
  key: 5,
  class: "row mb-sm-2"
}
const _hoisted_40 = { class: "col-sm-8" }
const _hoisted_41 = {
  key: 2,
  class: "row mt-3 row"
}
const _hoisted_42 = { class: "col-sm-8 offset-sm-4 ps-4 pe-4" }
const _hoisted_43 = ["disabled"]
const _hoisted_44 = {
  key: 1,
  class: "d-flex flex-row input-group"
}
const _hoisted_45 = ["disabled"]
const _hoisted_46 = {
  key: 3,
  class: "row mt-3"
}
const _hoisted_47 = { class: "col-12 text-end ps-4 pe-4" }
const _hoisted_48 = {
  key: 1,
  class: "mb-3 row"
}
const _hoisted_49 = { class: "col-sm-8" }
const _hoisted_50 = {
  key: 0,
  class: "text-danger fw-bold mt-2"
}
const _hoisted_51 = {
  key: 1,
  class: "text-danger small mt-1"
}
const _hoisted_52 = {
  key: 0,
  class: "d-flex flex-row ms-auto ps-4 pe-4 justify-content-end",
  style: {"width":"40%"}
}
const _hoisted_53 = {
  class: "btn-group",
  role: "group",
  style: {"width":"300px"}
}
const _hoisted_54 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_fa = _resolveComponent("fa")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[36] || (_cache[36] = _createElementVNode("div", { class: "row d-flex justify-content-center mt-3" }, [
      _createElementVNode("img", {
        alt: "Vue logo",
        src: _imports_0,
        class: "mt-2 text-center",
        style: {"max-width":"300px"}
      })
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, "お名前：" + _toDisplayString(_ctx.userInfo?.userName), 1)
    ]),
    (_ctx.done && !_ctx.taikaisyori)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, " 設定変更しました。 "))
      : _createCommentVNode("", true),
    (!_ctx.done)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("label", _hoisted_7, [
              (!_ctx.confirming)
                ? (_openBlock(), _createElementBlock("span", _hoisted_8, "必須"))
                : _createCommentVNode("", true),
              _cache[16] || (_cache[16] = _createTextVNode("ログインID （メールアドレス）", -1))
            ]),
            _createElementVNode("div", _hoisted_9, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                readonly: _ctx.confirming,
                onInput: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.loginIdOperation && _ctx.loginIdOperation(...args))),
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.kaiinJoho.webKaiinLoginId) = $event)),
                class: "form-control form-control-lg",
                maxlength: "100",
                style: _normalizeStyle({'background-color': _ctx.loginIdValid ? '' : 'lightpink'})
              }, null, 44, _hoisted_10), [
                [_vModelText, _ctx.kaiinJoho.webKaiinLoginId]
              ]),
              (_ctx.maiAddressMessage)
                ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(_ctx.maiAddressMessage), 1))
                : _createCommentVNode("", true)
            ])
          ]),
          (!_ctx.confirming)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _cache[17] || (_cache[17] = _createElementVNode("span", { class: "fw-bold" }, "メール受信許可設定のお願い", -1)),
                  _cache[18] || (_cache[18] = _createElementVNode("br", null, null, -1)),
                  _cache[19] || (_cache[19] = _createElementVNode("span", null, "携帯会社（通信回線事業者）のメールをご利用の方は下記ドメインからのメール受信許可の設定をお願いいたします。", -1)),
                  _cache[20] || (_cache[20] = _createElementVNode("br", null, null, -1)),
                  _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.configs['mail_domain']), 1)
                ]),
                _createElementVNode("div", _hoisted_15, [
                  _cache[21] || (_cache[21] = _createElementVNode("span", { class: "fw-bold" }, "設定方法については下記の携帯会社サイトをご参照ください。", -1)),
                  _cache[22] || (_cache[22] = _createElementVNode("br", null, null, -1)),
                  _createElementVNode("ul", null, [
                    _createElementVNode("li", null, [
                      _createElementVNode("a", {
                        href: _ctx.configs['keitai_kaisha_docomo'],
                        target: "_blank"
                      }, "NTTドコモ 受信リスト／拒否リスト設定", 8, _hoisted_16)
                    ]),
                    _createElementVNode("li", null, [
                      _createElementVNode("a", {
                        href: _ctx.configs['keitai_kaisha_au'],
                        target: "_blank"
                      }, "au(KDDI) 受信リスト設定", 8, _hoisted_17)
                    ]),
                    _createElementVNode("li", null, [
                      _createElementVNode("a", {
                        href: _ctx.configs['keitai_kaisha_softbank'],
                        target: "_blank"
                      }, "ソフトバンク 受信許可リスト設定", 8, _hoisted_18)
                    ]),
                    _createElementVNode("li", null, [
                      _createElementVNode("a", {
                        href: _ctx.configs['keitai_kaisha_rakuten'],
                        target: "_blank"
                      }, "楽天モバイル 受信リスト／拒否リストの設定・変更・削除（楽メール）", 8, _hoisted_19)
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (!_ctx.confirming || !!_ctx.password)
            ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                _cache[23] || (_cache[23] = _createElementVNode("label", { class: "col-form-label col-sm-4" }, "新しいパスワード", -1)),
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("div", _hoisted_22, [
                    _withDirectives(_createElementVNode("input", {
                      readonly: _ctx.confirming,
                      type: _ctx.showPassword ? 'type' :'password',
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.password) = $event)),
                      class: "form-control form-control-lg",
                      style: _normalizeStyle({'background-color': !_ctx.password ? '' : (_ctx.validPassword ? 'aquamarine' : 'lightpink')}),
                      maxlength: "32",
                      placeholder: "※パスワード変更する時は入力してください。"
                    }, null, 12, _hoisted_23), [
                      [_vModelDynamic, _ctx.password]
                    ]),
                    _createElementVNode("button", {
                      class: "btn btn-lg border-start-0 bg-white",
                      style: {"border-color":"lightgray"},
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showPassword=!_ctx.showPassword))
                    }, [
                      _createElementVNode("div", _hoisted_24, [
                        _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.showPassword ? '非表示' : '表示'), 1)
                      ]),
                      _createVNode(_component_fa, {
                        class: "me-1 text-primary",
                        icon: _ctx.showPassword ? 'eye-slash' : 'eye'
                      }, null, 8, ["icon"])
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (!_ctx.confirming)
            ? (_openBlock(), _createElementBlock("div", _hoisted_26, [...(_cache[24] || (_cache[24] = [
                _createElementVNode("div", { class: "offset-sm-4 ps-2" }, [
                  _createTextVNode(" 8～32文字で入力してください。"),
                  _createElementVNode("br"),
                  _createTextVNode(" 英文字(大文字、小文字)、数字、記号の2種類以上で作成してください。"),
                  _createElementVNode("br"),
                  _createTextVNode(" ※使用可能な記号  ! # $ % & / = ? @ ")
                ], -1)
              ]))]))
            : _createCommentVNode("", true),
          (!_ctx.confirming)
            ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                _cache[25] || (_cache[25] = _createElementVNode("label", { class: "col-form-label col-sm-4" }, "パスワード（確認用）", -1)),
                _createElementVNode("div", _hoisted_28, [
                  _createElementVNode("div", _hoisted_29, [
                    _withDirectives(_createElementVNode("input", {
                      readonly: _ctx.confirming,
                      onPaste: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["prevent"])),
                      type: _ctx.showPassword ? 'type' :'password',
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.confirmPassword) = $event)),
                      class: "form-control form-control-lg",
                      style: _normalizeStyle({'background-color': !_ctx.confirmPassword ? '' : ((_ctx.password===_ctx.confirmPassword) ? 'aquamarine' : 'lightpink')}),
                      maxlength: "32",
                      placeholder: "※パスワード変更する時は入力してください。"
                    }, null, 44, _hoisted_30), [
                      [_vModelDynamic, _ctx.confirmPassword]
                    ]),
                    _createElementVNode("button", {
                      class: "btn btn-lg border-start-0 bg-white",
                      style: {"border-color":"lightgray"},
                      onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.showPassword=!_ctx.showPassword))
                    }, [
                      _createElementVNode("div", _hoisted_31, [
                        _createElementVNode("span", _hoisted_32, _toDisplayString(_ctx.showPassword ? '非表示' : '表示'), 1)
                      ]),
                      _createVNode(_component_fa, {
                        class: "me-1 text-primary",
                        icon: _ctx.showPassword ? 'eye-slash' : 'eye'
                      }, null, 8, ["icon"])
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_33, [
            _createElementVNode("label", _hoisted_34, [
              (!_ctx.confirming)
                ? (_openBlock(), _createElementBlock("span", _hoisted_35, "必須"))
                : _createCommentVNode("", true),
              _cache[26] || (_cache[26] = _createTextVNode("氏名", -1))
            ]),
            _createElementVNode("div", _hoisted_36, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                readonly: _ctx.confirming,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.kaiinJoho.webKaiinName) = $event)),
                class: "form-control form-control-lg",
                maxlength: "32",
                style: _normalizeStyle({'background-color': _ctx.kaiinJoho.webKaiinName ? '' : 'lightpink'})
              }, null, 12, _hoisted_37), [
                [_vModelText, _ctx.kaiinJoho.webKaiinName]
              ])
            ])
          ]),
          (!_ctx.confirming)
            ? (_openBlock(), _createElementBlock("div", _hoisted_38, [...(_cache[27] || (_cache[27] = [
                _createElementVNode("div", { class: "offset-sm-4 ps-2" }, " 本人確認のためログインIDのメールアドレスに「日本歯科衛生協会 設定確認について」という件名で確認メールが送られます。 ", -1)
              ]))]))
            : _createCommentVNode("", true),
          (_ctx.confirming)
            ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                _cache[28] || (_cache[28] = _createElementVNode("label", { class: "col-form-label col-sm-4" }, [
                  _createElementVNode("span", { class: "badge bg-danger me-2" }, "必須"),
                  _createTextVNode("確認コード")
                ], -1)),
                _createElementVNode("div", _hoisted_40, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.confirmCode) = $event)),
                    class: "form-control form-control-lg",
                    maxlength: "6",
                    style: _normalizeStyle({'background-color': _ctx.validConfirmCode || !_ctx.confirmCode ? '' : 'lightpink'}),
                    placeholder: "※メールに記載されている確認コードを入力してください。"
                  }, null, 4), [
                    [_vModelText, _ctx.confirmCode]
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (!_ctx.done)
      ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
          _createElementVNode("div", _hoisted_42, [
            (!_ctx.confirming)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "btn btn-lg btn-primary text-white w-100",
                  disabled: !_ctx.canConfirm,
                  onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.confirm()))
                }, [
                  _createVNode(_component_fa, {
                    class: "me-1",
                    icon: "check"
                  }),
                  _cache[29] || (_cache[29] = _createTextVNode("確認する", -1))
                ], 8, _hoisted_43))
              : _createCommentVNode("", true),
            (_ctx.confirming)
              ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                  (_ctx.confirming)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        class: "btn btn-lg btn-lightgray text-white w-25",
                        onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.backFromConfirm()))
                      }, [
                        _createVNode(_component_fa, {
                          class: "me-1",
                          icon: "arrow-left"
                        }),
                        _cache[30] || (_cache[30] = _createTextVNode("戻る", -1))
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.confirming)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 1,
                        class: "btn btn-lg btn-primary text-white w-75",
                        disabled: !_ctx.validConfirmCode,
                        onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.updateSettings()))
                      }, [
                        _createVNode(_component_fa, {
                          class: "me-1",
                          icon: "save"
                        }),
                        _cache[31] || (_cache[31] = _createTextVNode("変更する", -1))
                      ], 8, _hoisted_45))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true),
    (!_ctx.deleteDone)
      ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
          _createElementVNode("div", _hoisted_47, [
            (!_ctx.deleteconfirming && !_ctx.done)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "btn btn-lg btn-secondary text-white ms-auto",
                  onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.sendTaikaiKakuninCode()))
                }, [
                  _createVNode(_component_fa, {
                    class: "me-1",
                    icon: "envelope"
                  }),
                  _cache[32] || (_cache[32] = _createTextVNode(" 退会へ", -1))
                ]))
              : _createCommentVNode("", true),
            (_ctx.deleteconfirming)
              ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                  _cache[33] || (_cache[33] = _createElementVNode("label", { class: "col-form-label col-sm-4 col-form-label fs-4" }, [
                    _createElementVNode("span", { class: "badge bg-danger me-3" }, "必須"),
                    _createTextVNode("確認コード")
                  ], -1)),
                  _createElementVNode("div", _hoisted_49, [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.confirmCode) = $event)),
                      class: "form-control form-control-lg",
                      maxlength: "6",
                      style: _normalizeStyle({'background-color': _ctx.validTaikai || !_ctx.confirmCode ? '' : 'lightpink'}),
                      placeholder: "※メールに記載されている確認コードを入力してください。"
                    }, null, 4), [
                      [_vModelText, _ctx.confirmCode]
                    ]),
                    (_ctx.errorMessage)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_50, _toDisplayString(_ctx.errorMessage), 1))
                      : _createCommentVNode("", true),
                    (_ctx.confirmCode && !_ctx.validTaikai)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_51, "半角数字6桁を入力してください。"))
                      : _createCommentVNode("", true)
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          (_ctx.deleteconfirming)
            ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                _createElementVNode("div", _hoisted_53, [
                  _createElementVNode("button", {
                    class: "btn btn-lg btn-lightgray text-white",
                    onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.backFromDeConfirm()))
                  }, [
                    _createVNode(_component_fa, {
                      class: "me-1",
                      icon: "arrow-left"
                    }),
                    _cache[34] || (_cache[34] = _createTextVNode("戻る", -1))
                  ]),
                  _createElementVNode("button", {
                    class: "btn btn-lg btn-secondary text-white",
                    disabled: !_ctx.validTaikai,
                    onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.taikaiSyori()))
                  }, [
                    _createVNode(_component_fa, {
                      class: "me-1",
                      icon: "trash-can"
                    }),
                    _cache[35] || (_cache[35] = _createTextVNode("退会", -1))
                  ], 8, _hoisted_54)
                ])
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
}